import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
import Placeholder from '@tiptap/extension-placeholder';
import Underline from '@tiptap/extension-underline';
import TextAlign from '@tiptap/extension-text-align';
import Color from '@tiptap/extension-color';
import { BackgroundColor, FontFamily, FontSize, TextStyle } from '@tiptap/extension-text-style';
import { BrandColor } from './BrandColor.js';
import { contentLayoutExtensions } from './ContentLayout.js';

export function createContentEditorExtensions(preset, { placeholder = 'Start writing…', extensions = [], trailingNode = true } = {}) {
  const headings = preset === 'basic' ? [2, 3] : [1, 2, 3, 4, 5, 6];
  return [
    StarterKit.configure({ heading: { levels: headings }, link: false, underline: false, trailingNode: trailingNode ? {} : false }),
    Underline,
    TextAlign.configure({ types: ['heading', 'paragraph'] }),
    Link.configure({ openOnClick: false, autolink: true, defaultProtocol: 'https', HTMLAttributes: { target: '_blank', rel: 'noopener noreferrer' } }),
    Placeholder.configure({ placeholder: ({ node }) => node.type.name === 'paragraph' ? placeholder : node.type.name === 'heading' ? 'Heading' : '', includeChildren: true, showOnlyCurrent: false }),
    TextStyle,
    Color,
    FontSize,
    FontFamily,
    BackgroundColor,
    BrandColor,
    ...(preset === 'article' ? contentLayoutExtensions : []),
    ...extensions,
  ];
}
